module.exports = __webpack_public_path__ + "carousel2.e827a2d7.jpg";